module.exports = __webpack_public_path__ + "static/media/invited-by-aero.8429d6e3.svg";